@if (on ==='form' && attachmentGridField.visible.form) {
    @if(attachmentGridField.showGrid) {
        <app-grid [control]="control" [on]="on"></app-grid>
    }
    @if(attachmentGridField.showSimple) {
        <ng-container [ngTemplateOutlet]="showSimple"></ng-container>
    }
    @if (attachmentGridField.allowSimpleAdd || attachmentGridField.showSimple) {
        <ng-container [ngTemplateOutlet]="showSimpleAdd"></ng-container>
    }
    <div style="height:21px" [attr.data-uploads-complete]="uploadsCompleted">
            <input type="file"  style="visibility:hidden"
            #fileDropRef id="fileDropRef" multiple (change)="fileBrowseHandler($event.target.files)" />
    </div>
    @if (!control.field.readonly && attachmentGridField.showGrid) {
        <ng-container [ngTemplateOutlet]="gridAddBox"></ng-container>
    }
}

<ng-template #gridAddBox>
    <table>
        <tr>
          <td matTooltip="Click here to add a file or image">
            <button mat-raised-button color="primary" style="font-size: small;" (click)="clickAddFiles()"
              data-grid-new>
              Attach File(s)
            </button>
          </td>
          <td>
            <table width="100%">
              @for (file of files; track file; let i = $index) {
                <tr>
                  <td>
                    @if (file.progress < 100) {
                      <h4 class="name">
                        {{ file?.name }}
                      </h4>
                    }
                    @if (file.progress >= 100) {
                      <h4 class="name" >
                        {{ file?.name }} - Uploaded
                      </h4>
                    }
                  </td>
                  <td>
                    <p class="size">
                      {{ file?.size | byteCount }} @if (file?.failed) {
                      <span i18n >Upload has failed...</span>
                    }
                  </p>
                </td>
                <td width="50%">
                  <app-upload-progress [upFile]="file"></app-upload-progress>
                </td>
              </tr>
            }
          </table>
        </td>
      </tr>
    </table>
</ng-template>

<ng-template #showSimple>
    <div class="sec-panel">
        <h3 class="sec-head"><span i18n>Attachments</span>
            <app-section-action-button i18n-label label="Expand" icon="zoom_out_map"
                i18n-tip tip="Open the attachments in a larger window"
                (act)="openBigList()"></app-section-action-button>
        </h3>
        <div class="rows-scroll">
            @for (a of attachmentGridField.attachmentList; track $index) {
                <div class="simple-row">
                    <div class="simple-icon">
                        @if (attachmentGridField.getFileIcon(a) === 'attachment') {
                            <mat-icon class="image" color="primary">attachment</mat-icon>
                        } @else {
                            <img src="./assets/{{ attachmentGridField.getFileIcon(a) }}" alt="File">
                        }
                    </div>

                    <div class="simple-body">
                        <a class="primary-font-color simple-name" #tooltip="matTooltip"
                            matTooltip="Created : {{ a.createdAt | fromNow }} Size: {{ a.size | byteCount }}"
                            href="" (click)="openAttachment($event, a)">{{ a.name }}</a>
                        @if (a.notes) {
                            <div class="simple-notes">{{ a.notes }}</div>
                        }
                    </div>

                    <div class="simple-actions">
                        @if (!attachmentGridField.readonly) {
                            @if (attachmentGridField.allowSimpleEdit) {
                                <mat-icon class="edits hover-action" color="primary" (click)="editAttachment(a)">edit</mat-icon>
                            }
                            @if (attachmentGridField.allowSimpleDelete) {
                                <mat-icon class="edits hover-action" color="warn" (click)="deleteAttachment(a)">delete</mat-icon>
                            }
                        }
                        <mat-icon class="edits info" (click)="tooltip.show()">info</mat-icon>
                    </div>
                </div>
            } @empty {
                <div class="simple-empty">
                    @if (attachmentGridField.readonly) {
                        <span i18n>No attachments</span>
                    } @else {
                        <span i18n>Click the button below to attach a file</span>
                    }
                </div>
            }
        </div>
    </div>
</ng-template>
<ng-template #showSimpleAdd>
    @if (!control.field.readonly) {
        <app-add-item-button i18n-tip tip="Click to add a file" (add)="clickAddFiles()"></app-add-item-button>
    }
</ng-template>
